import { render, staticRenderFns } from "./choose-device.vue?vue&type=template&id=582e8856&scoped=true"
import script from "./choose-device.vue?vue&type=script&lang=js"
export * from "./choose-device.vue?vue&type=script&lang=js"
import style0 from "./choose-device.vue?vue&type=style&index=0&id=582e8856&prod&scoped=true&lang=css"
import style1 from "./choose-device.vue?vue&type=style&index=1&id=582e8856&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582e8856",
  null
  
)

export default component.exports